import React from "react";
import "../../screening-test/index.css";
import arrowImage from "../../../../assets/arrow.png";
import axios from "axios";
import resultImageG01 from "../../../../assets/FlatChartG01.svg";
import resultImageG02 from "../../../../assets/FlatChartG02.svg";
import resultImageO01 from "../../../../assets/FlatChartO01.svg";
import resultImageO02 from "../../../../assets/FlatChartO02.svg";
import resultImageR01 from "../../../../assets/FlatChartR01.svg";
import resultImageR02 from "../../../../assets/FlatChartR02.svg";

const faQuestions = require("../../../../utils/scoboTestQuestionsFa.js");
const engQuestions = require("../../../../utils/scoboTestQuestionsEng.js");
const faAnswers = require("../../../../utils/scoboTestAnswersFa");
const engAnswers = require("../../../../utils/scoboTestAnswersEng");
const ageSelectionQuestions = require("../../../../utils/autismSelectAge.js");
const faTestResults = require("../../../../utils/scoboTestResultsFa.js");
const engTestResults = require("../../../../utils/scoboTestResultsEng.js");

class TestAutismScreening extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      accessType: "User",
      scoboResult: null,
      autismBackground: "",
      autismDiagnosis: "",
      childAge: 0,
      userId: 0,
      questionsCounter: 0,
      questionsToShow: [],
      questionsSelectionByAge: [0],
      previousCount: 0,
      questionNumber: 0,
      questionsTotalNumber: 68,
      questions: {},
      screeningAnswer: [],
      screeningbooking: false,
      execute: false,
      results: {},
      finishedAnswering: false,
      resultNumber: 0,
      countryCode: "IR", // this.props.languageInput,
      testAnswersOptions: [],
      testResultsText: [],
      isLoaded: false,
      pictureSelector: "",
    };
  }

  componentDidMount = async () => {
    // const lang = localStorage.getItem('lang')
    // if(lang==null){
    //   if(this.state.countryCode == 'IR' ){
    //     this.setState({questionsToShow: [...faQuestions]})
    //     this.setState({testAnswersOptions: [...faAnswers]})
    //     this.setState({testResultsText: [...faTestResults]})
    //   } else {
    //     this.setState({questionsToShow: [...engQuestions]})
    //     this.setState({testAnswersOptions: [...engAnswers]})
    //     this.setState({testResultsText: [...engTestResults]})
    //   }
    // } else if(lang =='IR'){
    //   this.setState({questionsToShow: [...faQuestions]})
    //   this.setState({testAnswersOptions: [...faAnswers]})
    //   this.setState({testResultsText: [...faTestResults]})
    // } else {
    //   this.setState({questionsToShow: [...engQuestions]})
    //   this.setState({testAnswersOptions: [...engAnswers]})
    //   this.setState({testResultsText: [...engTestResults]})
    // }

    this.setState({ questionsToShow: [...faQuestions] });
    this.setState({ testAnswersOptions: [...faAnswers] });
    this.setState({ testResultsText: [...faTestResults] });

    const response = await axios.post(
      "https://request.kidiar.com/evaluation/request",
      { testName: "SCOBO" },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.status == 0) {
      window.location.href = "/fa/panel/evaluations/list?test=SCOBO"; // It could be changes to show some message to user
    }
    this.setState({ userId: response.data.audienceId });
    this.setState({ accessType: response.data.access });
    var receivedAge = response.data.age;

    if (response.data.age < 24) receivedAge = 0;
    else if (response.data.age < 36) receivedAge = 1;
    else if (response.data.age < 48) receivedAge = 2;
    else receivedAge = 3;
    this.setState({ childAge: receivedAge });

    this.setState({
      questionsSelectionByAge: [...ageSelectionQuestions[receivedAge]],
    });
    this.setState({
      questionsTotalNumber: ageSelectionQuestions[receivedAge].length - 1,
    });
  };

  // componentDidUpdate = () => {
  //   if (this.props.languageInput != this.state.countryCode) {
  //     this.setState({countryCode: this.props.languageInput})
  //     if(this.props.languageInput == 'IR' ){
  //       this.setState({questionsToShow: [...faQuestions]})
  //       this.setState({testAnswersOptions: [...faAnswers]})
  //       this.setState({testResultsText: [...faTestResults]})
  //     } else {
  //       this.setState({questionsToShow: [...engQuestions]})
  //       this.setState({testAnswersOptions: [...engAnswers]})
  //       this.setState({testResultsText: [...engTestResults]})
  //     }
  //   }
  // }

  questionChildNoSpeak = () => {
    if (this.state.childAge == 0) {
      this.state.questionsSelectionByAge.splice(39, 2);
      this.setState({
        questionsTotalNumber: this.state.questionsSelectionByAge.length - 1,
      });
    }

    if (this.state.childAge == 1) {
      this.state.questionsSelectionByAge.splice(40, 2);
      this.state.questionsSelectionByAge.splice(41, 7);
      this.setState({
        questionsTotalNumber: this.state.questionsSelectionByAge.length - 1,
      });
    }

    if (this.state.childAge == 2) {
      this.state.questionsSelectionByAge.splice(39, 1);
      this.state.questionsSelectionByAge.splice(44, 8);
      this.setState({
        questionsTotalNumber: this.state.questionsSelectionByAge.length - 1,
      });
    }

    if (this.state.childAge == 3) {
      this.state.questionsSelectionByAge.splice(40, 1);
      this.state.questionsSelectionByAge.splice(45, 8);
      this.setState({
        questionsTotalNumber: this.state.questionsSelectionByAge.length - 1,
      });
    }
  };

  screeningAnswerHandler = (value) => {
    this.state.questions[
      this.state.questionsSelectionByAge[this.state.questionsCounter]
    ] = value;
    console.log(this.state.questions);

    if (this.state.previousCount > 0) {
      this.setState({ previousCount: this.state.previousCount - 1 });
    }

    if (this.state.questionsCounter == 0 && value != 1) {
      this.setState({
        questionsTotalNumber: this.state.questionsSelectionByAge.length - 1,
      });
    }
    if (this.state.questionsCounter == 0 && value == 1) {
      this.questionChildNoSpeak();
    }
    if (this.state.questionsCounter != this.state.questionsTotalNumber) {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
    } else {
      this.setState({ finishedAnswering: true });
      this.sendAnsweredQuestions();
    }
  };

  previousQuestionNumberHandler = () => {
    if (this.state.questionsCounter > 0) {
      this.setState({ questionsCounter: this.state.questionsCounter - 1 });
      this.setState({ previousCount: this.state.previousCount + 1 });
    }
    if (this.state.questionsCounter == 1) {
      this.state.childAge == 0 &&
        this.setState({
          questionsSelectionByAge: [...ageSelectionQuestions[0]],
        });
      this.state.childAge == 1 &&
        this.setState({
          questionsSelectionByAge: [...ageSelectionQuestions[1]],
        });
      this.state.childAge == 2 &&
        this.setState({
          questionsSelectionByAge: [...ageSelectionQuestions[2]],
        });
      this.state.childAge == 3 &&
        this.setState({
          questionsSelectionByAge: [...ageSelectionQuestions[3]],
        });
    }
  };

  nextQuestionNumberHandler = () => {
    if (this.state.previousCount > 0) {
      this.setState({ questionsCounter: this.state.questionsCounter + 1 });
      this.setState({ previousCount: this.state.previousCount - 1 });
    }
  };

  sendAnsweredQuestions = async () => {
    const results = await axios.post(
      "https://request.kidiar.com/evaluation/evaluate",
      {
        audienceId: this.state.userId,
        age: this.state.childAge, // 0, 1, 2, 3
        sex: this.state.gender,
        hasAutism: this.state.autismBackground,
        diagAutism: this.state.autismDiagnosis,
        questions: Object.keys(this.state.questions),
        answers: Object.values(this.state.questions),
        test: "SCOBO",
      },
      {
        headers: { "x-access-token": localStorage.getItem("token") },
      }
    );
    console.log("server answer is: ", results.data);
    this.setState({ scoboResult: results.data.result });
  };

  render() {
    if (this.state.scoboResult != null) {
      if (this.state.scoboResult.Result == 1) {
        this.setState({ pictureSelector: resultImageG02 });
      }
      if (this.state.scoboResult.Result == 2) {
        this.setState({ pictureSelector: resultImageO02 });
      }
      if (this.state.scoboResult.Result == 3) {
        this.setState({ pictureSelector: resultImageR02 });
      }

      return (
        <div className="result-page">
          <div className="result-page-container">
            <div className="result-page-right-wrapper">
              {this.state.scoboResult.Result == 1 && (
                <img
                  src={this.state.pictureSelector}
                  className="result-answer"
                ></img>
              )}
              {this.state.scoboResult.Result == 2 && (
                <img src={resultImageO02} className="result-answer"></img>
              )}
              {this.state.scoboResult.Result == 3 && (
                <img src={resultImageR02} className="result-answer"></img>
              )}
            </div>
            <div className="result-page-left-wrapper">
              {this.state.scoboResult.Result == 1 && (
                <div className="result-answer-text">
                  {this.state.testResultsText[1]}
                </div>
              )}

              {this.state.scoboResult.Result == 2 && (
                <div className="result-answer-text">
                  {this.state.testResultsText[2]}
                </div>
              )}
              {this.state.scoboResult.Result == 2 && (
                <p className="result-answer-title mt-1">
                  {this.state.testResultsText[3]}
                </p>
              )}

              {this.state.scoboResult.Result == 3 && (
                <div className="result-answer-text">
                  {this.state.testResultsText[4]}
                </div>
              )}
              {this.state.scoboResult.Result == 3 && (
                <p className="result-answer-title mt-1">
                  {this.state.testResultsText[5]}
                </p>
              )}
              <div className="d-flex">
                {this.state.accessType != "User" && (
                  <a
                    href={`/fa/panel/evaluations/list/results?id=${this.state.userId}`}
                  >
                    {" "}
                    {"رفتن به صفحه نتایج"}{" "}
                  </a>
                )}
                <a href="/fa/panel"> {"بازگشت به داشبورد"} </a>
              </div>
            </div>
          </div>
        </div>
      );
    }

    if (this.state.finishedAnswering == true) {
      return (
        <div className="screening-test" style={{ backgroundImage: "none" }}>
          {this.state.testResultsText[0]}
        </div>
      );
    }

    return (
      <div
        className={
          this.state.countryCode == "IR"
            ? "screening-test"
            : "screening-test-eng"
        }
        style={{ backgroundImage: "none" }}
      >
        <button
          onClick={() => this.nextQuestionNumberHandler()}
          className="pushButton-next-question"
        >
          <img src={arrowImage}></img>
        </button>
        <div className="test-container">
          <div className="question-number">
            {this.state.questionsCounter}/{this.state.questionsTotalNumber}
          </div>
          <div className="container-screening-question">
            <div className="screening-test-question">
              <p>
                {
                  this.state.questionsToShow[
                    this.state.questionsSelectionByAge[
                      this.state.questionsCounter
                    ]
                  ]
                }
              </p>
            </div>
          </div>
          <div className="container-screening-answer">
            <button
              onClick={() => this.screeningAnswerHandler(4)}
              className="screening-answer-option mode-bg-2"
            >
              {this.state.testAnswersOptions[0]}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(3)}
              className="screening-answer-option mode-bg-2"
            >
              {this.state.testAnswersOptions[1]}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(2)}
              className="screening-answer-option mode-bg-2"
            >
              {this.state.testAnswersOptions[2]}
            </button>
            <button
              onClick={() => this.screeningAnswerHandler(1)}
              className="screening-answer-option mode-bg-2"
            >
              {this.state.testAnswersOptions[3]}
            </button>
          </div>
        </div>
        <button
          onClick={() => this.previousQuestionNumberHandler()}
          className="pushButton-previous-question"
        >
          <img src={arrowImage}></img>
        </button>
      </div>
    );
  }
}

export default TestAutismScreening;
